import styled from 'styled-components';

import colours from 'theme/atoms/colours';
import { BaseCard } from 'theme/components/Cards.style';
import * as Text from 'theme/components/Text.style';

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
`;

export const LabelGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
`;

export const DateTimeLabel = styled(Text.LabelSemibold)`
  color: ${colours.neutral[900]};
`;

export const EditorLabel = styled(Text.Label)`
  color: ${colours.neutral[600]};
`;

export const Card = styled(BaseCard)`
  border-radius: 30px;
  gap: 0;
  padding: 15px;
`;

export const RevisionBody = styled(Text.P2)`
  color: ${colours.neutral[900]};
  white-space: pre-wrap;
  word-break: break-word;
`;
